import React from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

import './index.scss';

interface SettingSliderProp {
    min: number,
    max: number,
    label: string,
    value: number
    onChange?: (updatedValue: number) => void
}

export const SettingSlider = (props: SettingSliderProp) => {

    const { min, max, label, value, onChange } = props

    return (
        <div className="sliderDiv">
            <span>{label}</span>

            <Slider onChange={(updatedValue) => {
                onChange && onChange(typeof updatedValue === 'number' ? updatedValue : updatedValue[updatedValue.length - 1])
            }} min={min} max={max} value={value} />
        </div>
    )
}